<div class="import-preview">
  <h2 mat-dialog-title>Resultado da importação</h2>

  <mat-dialog-content>
    <p class="arquivo">
      <mat-icon>description</mat-icon>
      {{resumo.arquivo}}
    </p>

    <div class="resumo-cards">
      <div class="resumo-card">
        <span class="numero">{{resumo.total}}</span>
        <span class="rotulo">linhas lidas</span>
      </div>
      <div class="resumo-card valido">
        <span class="numero">{{resumo.validos}}</span>
        <span class="rotulo">válidas e selecionadas</span>
      </div>
      <div class="resumo-card invalido">
        <span class="numero">{{resumo.invalidos.length}}</span>
        <span class="rotulo">não encontradas</span>
      </div>
    </div>

    @if (temInvalidos) {
      <p class="aviso">
        <mat-icon>info</mat-icon>
        As linhas abaixo não foram associadas a nenhum pedido da lista carregada.
        Verifique se o período e os filtros da tela incluem esses pedidos.
      </p>

      <table mat-table [dataSource]="resumo.invalidos" class="tabela-invalidos">
        <ng-container matColumnDef="linha">
          <th mat-header-cell *matHeaderCellDef>Linha</th>
          <td mat-cell *matCellDef="let item">{{item.linha}}</td>
        </ng-container>

        <ng-container matColumnDef="valor">
          <th mat-header-cell *matHeaderCellDef>Nº do pedido</th>
          <td mat-cell *matCellDef="let item">{{item.valor || '—'}}</td>
        </ng-container>

        <ng-container matColumnDef="motivo">
          <th mat-header-cell *matHeaderCellDef>Motivo</th>
          <td mat-cell *matCellDef="let item">{{item.motivo}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    } @else {
      <p class="tudo-certo">
        <mat-icon>check_circle</mat-icon>
        Todas as linhas foram associadas a pedidos e já estão selecionadas na tela.
      </p>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    @if (temInvalidos) {
      <button mat-stroked-button (click)="baixarInvalidos()">
        <mat-icon>file_download</mat-icon>
        Baixar não encontradas
      </button>
    }
    <button mat-raised-button color="primary" (click)="fechar()">Fechar</button>
  </mat-dialog-actions>
</div>
